import React from 'react';
import InstapayAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/InstapayAppIcon';

import Spacer20 from '../../../Misc/Spacer20.js';
import PayoutsButton from '../OtherComponents/PayoutsButton';

const InstapayStrategy = {
  previewInfo: {
    name: 'Instapay',
    iconSvg: <InstapayAppIcon size="xlarge" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Instapay',
    category: 'Make everyday payday',
    details: (
      <div>
        <div>
          With InstaPay your money goes from your customer’s hand to your bank account in 30 minutes or less. Never
          stress about buying materials or having cash on hand for payroll ever again.
        </div>
        <Spacer20 />
        <div>
          Housecall Pro is the <span style={{ fontWeight: 500 }}>only platform</span> that allows you to get paid
          instantly and free up cash flow for all your business needs.
        </div>
        <Spacer20 />
        Don&apos;t see Instapay as an option on your Payouts page? Check{' '}
        <a href="http://help.housecallpro.com/payments/instapay/instapay-faq" target="_blank" rel="noreferrer">
          {' '}
          eligibility requirements{' '}
        </a>{' '}
        here to see if you qualify.
      </div>
    ),
    iconSvg: <InstapayAppIcon size="xlarge" />,
  },
  sellingPoints: {
    headline: 'How to set up Instapay',
    description: '',
    unorderedPoints: [
      'Go to your payouts page',
      'Add a debit card and confirm your identity verification information',
      'Get paid instantly',
    ],
  },
  media: {
    wistiaLink: 'https://fast.wistia.net/embed/iframe/2jdfvsnsz2?autoPlay=false',
  },
  price: {
    hideToggle: true,
    hideCard: true,
    appActionButton: <PayoutsButton appPathName="instapay" appName="Instapay" />,
  },
};

export default InstapayStrategy;
